//React
import React, { useState, useEffect, useCallback, useRef } from "react";
import { Link } from "react-router-dom";

//Libs
import { Button, Dropdown, Icon, Popup } from "semantic-ui-react";
import swal from "sweetalert";

//Services
import { producaov2 as api } from "../../../../services/apis";
import { systemLogs } from "../../../../services/system_logs";
import { useRouter } from "../../../../hooks/router";

//Components
import AdminMenu from "../../../../components/Admin/MenuDetalhes/AdminMenu";

import Loader from "../../../../components/Loader";
import Loading from "../../../../components/Loading";
import ReactHtmlParser from "react-html-parser";
// import Popup from "reactjs-popup";

import * as yup from "yup";

//Styles
import {
  Container,
  QuestaoContainer,
  OpcaoContainer,
  SaveContainer,
  Title,
  Content,
  ContainerInputSearch,
  Input,
  Checkbox,
  SemanticTable,
  Section,
  SectionTitle,
  Label,
  Fieldset,
  Image,
  FormContainer,
  SubSection,
  SubsubSection,
  SubSectionTitle,
  SubsubSectionTitle,
  SubSectionList,
  SubsubSectionList,
  FieldsetContainer,
  SubSectionsContainer,
  FixedBottomContainer,
  AcademyChange,
  // Iframe,
} from "./styles";
import TextEditor from "../../../../components/Admin/StatefulTextEditor";
import { generateJSID } from "../../../../utils/Utils";
import Iframe from "../../../../components/Admin/Iframe";
import LessonAnexo from "../../../../components/Admin/LessonAnexo";

const CriarTeste = () => {
  const [curso, setCurso] = useState({});
  const [treinamento, setTreinamento] = useState({});
  const [consultor, setConsultor] = useState({});
  const [modulos, setModulos] = useState([]);
  const [testes, setTestes] = useState([]);
  const [changedState, setChangedState] = useState({
    curso: {},
    treinamento: {},
    consultor: {},
    modulos: [],
  });

  const [previousState, setPreviousState] = useState({
    curso: {},
    treinamento: {},
    consultor: {},
    modulos: [],
  });

  const [loading, setLoading] = useState(true);

  const [cursoSectionActive, setCursoSectionActive] = useState(true);
  const [treinamentoSectionActive, setTreinamentoSectionActive] = useState(
    true
  );
  const [consultorSectionActive, setConsultorSectionActive] = useState(true);
  const [moduloSectionActive, setModuloSectionActive] = useState(false);
  const [modulosSectionActive, setModulosSectionActive] = useState(true);
  const [licoesArrSectionActive, setLicoesArrSectionActive] = useState([]);
  const [original, setOriginal] = useState(1);
  const [associationLicoesTestes, setAssociationLicoesTestes] = useState([]);

  const [academyHistory, setAcademyHistory] = useState(null);

  const router = useRouter();

  const { academy_history } = router.query;

  const academyStatusOptions = [
    {
      key: 0,
      text: "Não finalizado",
      value: 0,
    },
    {
      key: 1,
      text: "Não publicado",
      value: 1,
    },
    {
      key: 2,
      text: "Em análise",
      value: 2,
    },
    {
      key: 3,
      text: "Com erros",
      value: 3,
    },
    {
      key: 4,
      text: "Publicado",
      value: 4,
    },
  ];

  const handleCursoInput = useCallback(
    (e) => {
      const { name, value } = e.target;

      setChangedState((changedState) => ({
        ...changedState,
        curso: {
          ...changedState.curso,
          id: curso.id,
          [name]: value,
        },
      }));

      setCurso((curso) => ({ ...curso, [name]: value }));
    },
    [curso]
  );

  const handleCursoToggle = useCallback(
    (e, toggleFunction) => {
      const { name, value } = e.target;

      setChangedState((changedState) => ({
        ...changedState,
        curso: {
          ...changedState.curso,
          id: curso.id,
          [name]: toggleFunction(value),
        },
      }));

      setCurso((curso) => ({ ...curso, [name]: toggleFunction(value) }));
    },
    [curso]
  );

  const handleTreinamentoInput = useCallback(
    (e) => {
      const { name, value } = e.target;

      setChangedState((changedState) => ({
        ...changedState,
        treinamento: {
          ...changedState.treinamento,
          id: treinamento.id,
          [name]: value,
        },
      }));

      setTreinamento((treinamento) => ({ ...treinamento, [name]: value }));
    },
    [treinamento]
  );

  const handleConsultorInput = useCallback(
    (e) => {
      const { name, value } = e.target;

      setChangedState((changedState) => ({
        ...changedState,
        consultor: {
          ...changedState.consultor,
          id: consultor.id,
          [name]: value,
        },
      }));

      setConsultor((consultor) => ({ ...consultor, [name]: value }));
    },
    [consultor]
  );

  const handleModuloInput = useCallback(
    (e, index) => {
      const { name, value } = e.target;

      const { modulos: changedStateModulos } = changedState;

      const changedModulos = [...changedStateModulos];

      changedModulos[index][name] = value;
      changedModulos[index].id = modulos[index].id;

      setChangedState((changedState) => ({
        ...changedState,
        modulos: changedModulos,
      }));

      const newModulos = [...modulos];

      newModulos[index][name] = value;

      setModulos(newModulos);
    },
    [modulos, changedState]
  );

  const handleLicaoInput = useCallback(
    (e, indexModulo, indexLicao) => {
      const { name, value } = e.target;

      // const changedModulos = [...changedState.modulos];

      const { modulos: changedStateModulos } = changedState;

      const changedModulos = [...changedStateModulos];

      changedModulos[indexModulo].licoes[indexLicao][name] = value;

      changedModulos[indexModulo].licoes[indexLicao].id =
        modulos[indexModulo].licoes[indexLicao].id;

      setChangedState((changedState) => ({
        ...changedState,
        modulos: changedModulos,
      }));

      const newModulos = [...modulos];

      const licoes = [...newModulos[indexModulo].licoes];

      licoes[indexLicao][name] = value;

      newModulos[indexModulo].licoes = licoes;

      setModulos(newModulos);
    },
    [modulos, changedState]
  );

  const academyCursoLoad = useCallback(
    async (original = 0) => {
      const { id_curso } = router.query;
      try {
        const {
          item: { curso, treinamento, consultor, modulos, testes },
        } = (
          await api.get(`admin/academy/cursos/${id_curso}`, {
            params: { original },
          })
        ).data;

        setCurso(curso);
        setTreinamento(treinamento);
        setConsultor(consultor);

        const licoesArrSectionActive = modulos.map((modulo) =>
          modulo.licoes.map((v) => false)
        );

        setLicoesArrSectionActive(licoesArrSectionActive);

        setModulos(modulos);

        setTestes(testes);

        setPreviousState({
          curso: { ...curso },
          treinamento: { ...treinamento },
          consultor: { ...consultor },
          modulos: [...modulos].map((modulo) => ({
            ...modulo,
            licoes: [...modulo.licoes].map((licao) => ({ ...licao })),
          })),
          testes: [...testes].map((teste) => ({
            ...teste,
          })),
        });

        const newAssociationLicoesTestes = modulos
          .map((modulo) =>
            modulo.licoes
              .filter(({ tipo }) => tipo === "teste")
              .map(({ id, anexo }) => ({
                id_licao: id,
                js_id_teste: anexo.split("://").pop(),
              }))
          )
          .reduce((sum, v) => sum.concat(v), [])
          .map((licao) => {
            const teste = testes.find(
              ({ js_id }) => js_id === licao.js_id_teste
            );

            return {
              id_teste: teste.id,
              js_id_teste: licao.js_id_teste,
              id_licao: licao.id_licao,
            };
          });

        setAssociationLicoesTestes(newAssociationLicoesTestes);

        setChangedState((changedState) => ({
          ...changedState,
          modulos: [...modulos].map((modulo) => ({
            ...modulo,
            licoes: [...modulo.licoes].map((licao) => ({})),
          })),
        }));

        setLoading(false);
      } catch (err) {
        swal("Erro", "Erro ao carregar teste", "error");
      }
    },
    [router]
  );

  const changesLoad = useCallback(async () => {
    try {
      const {
        data: { history },
      } = await api.get(`academy/histories/${academy_history}`);

      // setAcademyHistory(history);

      if (Number(history.status) == 1) {
        return null;
      }

      setAcademyHistory(history);

      return history;
    } catch (err) {
      return null;
    }
  }, [academy_history]);

  const initialLoad = useCallback(async () => {
    const history = await changesLoad();
    const original = !history ? 1 : 0;
    academyCursoLoad(original);
    setOriginal(original);
  }, [academyCursoLoad, changesLoad]);

  useEffect(() => {
    initialLoad();
  }, [router]);

  const handleAcademyStatusDropdown = useCallback((e, { value }) => {
    setChangedState((changedState) => ({
      ...changedState,
      curso: { ...changedState.curso, academy_status: value },
    }));

    setCurso((curso) => ({ ...curso, academy_status: value }));
  }, []);

  const handleTeste = useCallback(
    (teste) => {
      const foundIndex = testes
        ? testes
            .map(({ id }, index) => (id === teste.id ? index : -1))
            .filter((index) => index > -1)[0]
        : 0;

      const foundChangedIndex = changedState.testes
        ? changedState.testes
            .map(({ id }, index) => (id === teste.id ? index : -1))
            .filter((index) => index > -1)[0]
        : 0;

      const changedStateTestes = changedState.testes
        ? [...changedState.testes]
        : [];
      const newTestes = testes ? [...testes] : [];

      newTestes[foundIndex] = newTestes[foundIndex]
        ? { ...newTestes[foundIndex], ...teste }
        : { ...teste };

      changedStateTestes[foundChangedIndex] = changedStateTestes[
        foundChangedIndex
      ]
        ? { ...changedStateTestes[foundChangedIndex], ...teste }
        : { ...teste };

      setChangedState((changedState) => ({
        ...changedState,
        testes: changedStateTestes,
      }));

      setTestes(newTestes);
    },
    [testes, changedState]
  );

  const cursoSection = [
    {
      key: "id",
      label: "ID do Curso",
      readOnly: true,
    },
    {
      key: "curso",
      label: "Título do Curso",
      onChange: handleCursoInput,
    },
    {
      key: "url_amigavel",
      label: "URL do Curso",
      onChange: handleCursoInput,
    },
    {
      key: "carga_horaria",
      label: "Carga Horária",
      type: "number",
      onChange: handleCursoInput,
    },
    {
      key: "valor",
      label: "Valor do Curso",
      type: "number",
      onChange: handleCursoInput,
    },
    {
      key: "is_in_promocoes",
      label: "Está em promoções ?",
      type: "checkbox",

      onChange: (e) => handleCursoToggle(e, (value) => !JSON.parse(value)),
    },
    {
      key: "ativo",
      label: "Ativo ?",
      type: "checkbox",

      onChange: (e) =>
        handleCursoToggle(e, (value) =>
          value.toUpperCase() === "S" ? "N" : "S"
        ),
    },
    {
      key: "listar",
      label: "Listar ?",
      type: "checkbox",

      onChange: (e) =>
        handleCursoToggle(e, (value) => (Number(value) === 1 ? 0 : 1)),
    },
    {
      key: "academy_status",
      label: "Status no Voitto Academy",
      type: "select",
      options: academyStatusOptions,
      onChange: handleAcademyStatusDropdown,
    },
  ];

  const treinamentoSection = [
    {
      key: "id",
      label: "ID do Treinamento",
      readOnly: true,
    },
    {
      key: "slogan",
      label: "Slogan do Treinamento",
      onChange: handleTreinamentoInput,
    },
    {
      key: "sobre",
      label: "Descrição do Treinamento",
      onChange: handleTreinamentoInput,
      type: "html",
    },
    {
      key: "video",
      label: "Vídeo do Treinamento",
      onChange: handleTreinamentoInput,
      type: "iframe-youtube",
    },
    {
      key: "alvo",
      label: "Alvo do Treinamento",
      onChange: handleTreinamentoInput,
      type: "html",
    },
  ];

  const consultorSection = [
    {
      key: "id",
      label: "ID do Consultor",
      readOnly: true,
    },
    {
      key: "nome",
      label: "Nome do Consultor",
      onChange: handleConsultorInput,
    },
    {
      key: "curriculo",
      label: "Currículo do Consultor",
      onChange: handleConsultorInput,
    },
    {
      key: "imagem",
      label: "Imagem do Consultor",
      onChange: handleConsultorInput,
      type: "image",
    },
  ];

  const moduloSection = [
    {
      key: "id",
      label: "ID do Módulo",
      readOnly: true,
    },
    {
      key: "js_id",
      label: "JS_ID do Módulo",
      onChange: (e, index) => handleModuloInput(e, index),
    },
    {
      key: "titulo",
      label: "Título do Módulo",
      onChange: (e, index) => handleModuloInput(e, index),
    },
    {
      key: "ordem",
      label: "Ordem do Módulo",
      onChange: (e, index) => handleModuloInput(e, index),
    },
  ];

  const licaoSection = [
    {
      key: "id",
      label: "ID da Lição",
      readOnly: true,
    },
    {
      key: "js_id",
      label: "JS ID da Lição",
      onChange: (e, indexModulo, indexLicao) =>
        handleLicaoInput(e, indexModulo, indexLicao),
    },
    {
      key: "titulo",
      label: "Título da Lição",
      onChange: (e, indexModulo, indexLicao) =>
        handleLicaoInput(e, indexModulo, indexLicao),
    },
    {
      key: "ordem",
      label: "Ordem da Lição",
      onChange: (e, indexModulo, indexLicao) =>
        handleLicaoInput(e, indexModulo, indexLicao),
    },
    {
      key: "tipo",
      label: "Tipo da Lição",
      onChange: (e, indexModulo, indexLicao) =>
        handleLicaoInput(e, indexModulo, indexLicao),
    },
    {
      key: "anexo",
      label: "Anexo da Lição",
      onChange: (e, indexModulo, indexLicao) =>
        handleLicaoInput(e, indexModulo, indexLicao),
      type: "lesson-anexo",
      anexoTypeKey: "tipo",
    },
    {
      key: "opcional",
      label: "Opcional ?",
      onChange: (e, indexModulo, indexLicao) =>
        handleLicaoInput(e, indexModulo, indexLicao),
      type: "checkbox",
    },

    {
      key: "ativo",
      label: "Ativo ?",
      onChange: (e, indexModulo, indexLicao) =>
        handleLicaoInput(e, indexModulo, indexLicao),
      type: "checkbox",
    },
    {
      key: "video_alternativo",
      label: "Vídeo Alternativo ?",
      onChange: (e, indexModulo, indexLicao) =>
        handleLicaoInput(e, indexModulo, indexLicao),
    },
    {
      key: "libera_data",
      label: "Data de liberação",
      onChange: (e, indexModulo, indexLicao) =>
        handleLicaoInput(e, indexModulo, indexLicao),
    },
  ];

  const getTestsChanges = useCallback(
    (id_licao, tableName, academyHistoryChanges) => {
      if (tableName !== "ead_licoes") {
        return [];
      }

      const testeAssociation = associationLicoesTestes.find(
        (alt) => alt.id_licao === id_licao
      );

      const changesTest = academyHistoryChanges
        ? academyHistoryChanges.filter(
            (change) =>
              change.table_name === "ead_testes" &&
              Number(testeAssociation.id_teste) === Number(change.id_table)
          )
        : null;

      const teste = testes.find(
        (teste) => teste.id === testeAssociation.id_teste
      );

      return [changesTest, teste];
    },
    [associationLicoesTestes, testes]
  );

  const getFieldset = useCallback(
    (tableName, obj, field, indexI = 0, indexJ = 0) => {
      const { label, type, options, key, readOnly, onChange } = field;

      const change = academyHistory?.changes.find(
        (change) =>
          change.table_name === tableName &&
          change.field_name === key &&
          Number(obj.id) === Number(change.id_table)
      );

      const [changesTest, teste] = getTestsChanges(
        obj.id,
        tableName,
        academyHistory?.changes
      );

      const typeOptions = {
        checkbox: () => {
          return (
            <Fieldset changed={!!change}>
              <Label>{label}</Label>

              <Popup
                trigger={
                  <Checkbox
                    placeholder={label}
                    type="checkbox"
                    value={obj[key]}
                    checked={
                      ["S", "N"].includes(obj[key])
                        ? obj[key] === "S"
                        : obj[key]
                    }
                    name={key}
                    onChange={(e) => onChange(e, indexI, indexJ)}
                  />
                }
                position="top left"
                disabled={!academy_history || !change}
              >
                <AcademyChange>
                  <h1>Antes:</h1>
                  <section>
                    <p>{change?.previous_value}</p>
                  </section>
                  <h1>Depois:</h1>
                  <section>
                    <p>{change?.field_value}</p>
                  </section>
                </AcademyChange>
              </Popup>
            </Fieldset>
          );
        },
        select: () => {
          return (
            <Fieldset changed={!!change}>
              <Label>{label}</Label>

              <Popup
                trigger={
                  <Dropdown
                    placeholder={label}
                    fluid
                    selection
                    value={obj[key]}
                    options={options}
                    onChange={(e, obj) => onChange(e, obj, indexI, indexJ)}
                  />
                }
                position="top left"
                disabled={!academy_history || !change}
              >
                <AcademyChange>
                  <h1>Antes:</h1>
                  <section>
                    <p>{change?.previous_value}</p>
                  </section>
                  <h1>Depois:</h1>
                  <section>
                    <p>{change?.field_value}</p>
                  </section>
                </AcademyChange>
              </Popup>
            </Fieldset>
          );
        },
        html: () => {
          return (
            <Fieldset changed={!!change}>
              <Label>{label}</Label>
              <Popup
                trigger={
                  <Input
                    placeholder={label}
                    value={obj[key]}
                    name={key}
                    readOnly={readOnly}
                    onChange={(e) => onChange(e, indexI, indexJ)}
                  />
                }
                position="top left"
                disabled={!academy_history || !change}
              >
                <AcademyChange>
                  <h1>Antes:</h1>
                  <section>
                    <p>{change?.previous_value}</p>
                  </section>
                  <h1>Depois:</h1>
                  <section>
                    <p>{change?.field_value}</p>
                  </section>
                </AcademyChange>
              </Popup>
              {obj[key] && ReactHtmlParser(obj[key])}
            </Fieldset>
          );
        },
        image: () => {
          return (
            <Fieldset changed={!!change}>
              <Label>{label}</Label>
              <Popup
                trigger={
                  <Input
                    placeholder={label}
                    value={obj[key]}
                    name={key}
                    readOnly={readOnly}
                    onChange={(e) => onChange(e, indexI, indexJ)}
                  />
                }
                position="top left"
                disabled={!academy_history || !change}
              >
                <AcademyChange>
                  <h1>Antes:</h1>
                  <section>
                    <a href={change?.previous_value}>
                      {change?.previous_value}
                    </a>
                  </section>
                  <h1>Depois:</h1>
                  <section>
                    <a href={change?.field_value}>{change?.field_value}</a>
                  </section>
                </AcademyChange>
              </Popup>
              {obj[key] && <Image src={obj[key]} maxWidth={"300px"} />}
            </Fieldset>
          );
        },
        "iframe-youtube": () => {
          return (
            <Fieldset changed={!!change}>
              <Label>{label}</Label>
              <Popup
                trigger={
                  <Input
                    placeholder={label}
                    value={obj[key]}
                    name={key}
                    readOnly={readOnly}
                    onChange={(e) => onChange(e, indexI, indexJ)}
                  />
                }
                position="top left"
                disabled={!academy_history || !change}
              >
                <AcademyChange>
                  <h1>Antes:</h1>
                  <section>
                    <p>{change?.previous_value}</p>
                  </section>
                  <h1>Depois:</h1>
                  <section>
                    <p>{change?.field_value}</p>
                  </section>
                </AcademyChange>
              </Popup>
              {obj[key] && <Iframe src={obj[key]} youtube />}
            </Fieldset>
          );
        },
        "lesson-anexo": () => {
          return (
            <Fieldset changed={!!change || !!changesTest}>
              <Label>{label}</Label>

              <Popup
                trigger={
                  <Input
                    placeholder={label}
                    value={obj[key]}
                    name={key}
                    readOnly={readOnly}
                    onChange={(e) => onChange(e, indexI, indexJ)}
                  />
                }
                position="top left"
                disabled={!academy_history || !change}
              >
                <AcademyChange>
                  <h1>Antes:</h1>
                  <section>
                    <p>{change?.previous_value}</p>
                  </section>
                  <h1>Depois:</h1>
                  <section>
                    <p>{change?.field_value}</p>
                  </section>
                </AcademyChange>
              </Popup>

              {obj[key] && (
                <LessonAnexo
                  anexo={obj[key]}
                  tipo={modulos[indexI].licoes[indexJ].tipo}
                  changesTest={changesTest}
                  teste={teste}
                  original={!!change}
                  handleTeste={handleTeste}
                />
              )}
            </Fieldset>
          );
        },
      };

      if (typeOptions[type]) {
        return typeOptions[type]();
      }

      return (
        <Fieldset changed={!!change}>
          <Label>{label}</Label>

          <Popup
            trigger={
              <Input
                placeholder={label}
                value={obj[key]}
                name={key}
                readOnly={readOnly}
                onChange={(e) => onChange(e, indexI, indexJ)}
              />
            }
            position="top left"
            disabled={!academy_history || !change}
          >
            <AcademyChange>
              <h1>Antes:</h1>
              <section>
                <p>{change?.previous_value}</p>
              </section>
              <h1>Depois:</h1>
              <section>
                <p>{change?.field_value}</p>
              </section>
            </AcademyChange>
          </Popup>
        </Fieldset>
      );
    },
    [
      academy_history,
      academyHistory,
      JSON.stringify(modulos),
      getTestsChanges,
      handleTeste,
    ]
  );

  const getFieldsets = useCallback(
    (tableName, sectionObj, obj, indexI = 0, indexJ = 0) => {
      return sectionObj.map((field) => {
        return getFieldset(tableName, obj, field, indexI, indexJ);
      });
    },
    [getFieldset]
  );

  const handleLicaoSectionActive = useCallback(
    (indexModulo, indexLicao) => {
      const newLicoesArrSectionActive = [...licoesArrSectionActive];

      newLicoesArrSectionActive[indexModulo][
        indexLicao
      ] = !newLicoesArrSectionActive[indexModulo][indexLicao];

      setLicoesArrSectionActive(newLicoesArrSectionActive);
    },
    [licoesArrSectionActive]
  );

  const discardChanges = useCallback(() => {
    const { curso, treinamento, consultor, modulos, testes } = previousState;

    setCurso({ ...curso });
    setTreinamento({ ...treinamento });
    setConsultor({ ...consultor });
    setModulos(
      [...modulos].map((modulo) => ({
        ...modulo,
        licoes: [...modulo.licoes].map((licao) => ({ ...licao })),
      }))
    );
    setTestes([...testes]);
  }, [previousState, JSON.stringify(previousState.modulos)]);

  const identifyNullObject = (obj) => {
    if (Object.keys(obj).length === 0) {
      return null;
    }

    if (Array.isArray(obj)) {
      return obj.length !== 0
        ? obj.map((v) => identifyNullObject(v)).filter((v) => v).length !== 0
          ? obj.map((v) => identifyNullObject(v)).filter((v) => v)
          : null
        : null;
    }

    const filteredObjArr = Object.keys(obj)
      .filter((key) =>
        typeof obj[key] === "object" ? identifyNullObject(obj[key]) : obj[key]
      )
      .reduce((sum, key) => {
        sum[key] = obj[key];
        return sum;
      }, {});

    if (Object.keys(filteredObjArr).length === 0) {
      return null;
    }

    return filteredObjArr;
  };

  const cleanObject = (obj) => {
    const cleanedObject = identifyNullObject(obj) || {};

    const formatedObj = Object.keys(cleanedObject)
      .filter((key) => cleanedObject[key])
      .reduce((sum, key) => {
        sum[key] = cleanedObject[key];
        return sum;
      }, {});

    return formatedObj;
  };

  const saveChanges = useCallback(async () => {
    try {
      const { id_curso } = router.query;

      setPreviousState({
        curso: { ...curso },
        treinamento: { ...treinamento },
        consultor: { ...consultor },
        modulos: [...modulos].map((modulo) => ({
          ...modulo,
          licoes: [...modulo.licoes].map((licao) => ({ ...licao })),
        })),
      });

      const payload = cleanObject(changedState);

      if (Object.keys(payload).length === 0) {
        return;
      }

      await api.put(`admin/academy/cursos/${id_curso}`, payload);

      swal(
        "Informações salvas !",
        "As alterações no curso foram salvas com sucesso !",
        "success"
      );
    } catch (err) {
      console.error(err);
      swal("Ops", "Houve um erro ao salvar suas alterações", "error");
    }
  }, [router, changedState, curso, treinamento, consultor, modulos]);

  const acceptUserChanges = useCallback(async () => {
    try {
      await api.put(`academy/histories/${academyHistory.id}`, {
        status: 1,
      });

      swal(
        "Informações salvas !",
        "As alterações do usuário foram publicadas !",
        "success"
      );
    } catch (err) {
      console.error(err);
      swal("Ops", "Houve um erro ao salvar as alterações do usuário", "error");
    }
  }, [academyHistory]);

  const toggleOriginal = useCallback(() => {
    const newOriginal = Number(original) == 1 ? 0 : 1;

    academyCursoLoad(newOriginal);
    setOriginal(newOriginal);
  }, [original, academyCursoLoad]);

  return (
    <Container>
      <AdminMenu />
      <Content>
        {loading ? (
          <Loading msg={"Buscando curso..."} />
        ) : (
          <>
            <FormContainer>
              <Title>Academy Curso</Title>

              <Section>
                <SectionTitle
                  onClick={() =>
                    setCursoSectionActive(
                      (cursoSectionActive) => !cursoSectionActive
                    )
                  }
                >
                  Curso{" "}
                  <Icon
                    class="icon"
                    name={cursoSectionActive ? "angle up" : "angle down"}
                  ></Icon>
                </SectionTitle>

                <FieldsetContainer active={cursoSectionActive}>
                  {cursoSectionActive &&
                    getFieldsets("curso", cursoSection, curso)}
                </FieldsetContainer>
              </Section>
              <Section>
                <SectionTitle
                  onClick={() =>
                    setTreinamentoSectionActive(
                      (treinamentoSectionActive) => !treinamentoSectionActive
                    )
                  }
                >
                  Treinamento{" "}
                  <Icon
                    class="icon"
                    name={treinamentoSectionActive ? "angle up" : "angle down"}
                  ></Icon>
                </SectionTitle>
                <FieldsetContainer active={treinamentoSectionActive}>
                  {treinamentoSectionActive &&
                    getFieldsets(
                      "treinamento",
                      treinamentoSection,
                      treinamento
                    )}
                </FieldsetContainer>
              </Section>
              <Section>
                <SectionTitle
                  onClick={() =>
                    setConsultorSectionActive(
                      (consultorSectionActive) => !consultorSectionActive
                    )
                  }
                >
                  Consultor{" "}
                  <Icon
                    class="icon"
                    name={consultorSectionActive ? "angle up" : "angle down"}
                  ></Icon>
                </SectionTitle>
                <FieldsetContainer active={consultorSectionActive}>
                  {consultorSectionActive &&
                    getFieldsets("consultores", consultorSection, consultor)}
                </FieldsetContainer>
              </Section>
              <Section>
                <SectionTitle
                  onClick={() =>
                    setModulosSectionActive(
                      (modulosSectionActive) => !modulosSectionActive
                    )
                  }
                >
                  Módulos{" "}
                  <Icon
                    class="icon"
                    name={modulosSectionActive ? "angle up" : "angle down"}
                  ></Icon>
                </SectionTitle>

                <SubSectionsContainer active={modulosSectionActive}>
                  {modulosSectionActive &&
                    modulos.map((modulo, indexModulo) => (
                      <SubSection>
                        <SectionTitle
                          onClick={() =>
                            setModuloSectionActive(
                              (moduloSectionActive) => !moduloSectionActive
                            )
                          }
                        >
                          Módulo: {modulo.titulo} [{modulo.id}]
                          <Icon
                            class="icon"
                            name={
                              moduloSectionActive ? "angle up" : "angle down"
                            }
                          ></Icon>
                        </SectionTitle>
                        <FieldsetContainer active={moduloSectionActive}>
                          {moduloSectionActive &&
                            getFieldsets(
                              "ead_modulos",
                              moduloSection,
                              modulo,
                              indexModulo
                            )}
                        </FieldsetContainer>

                        {modulo.licoes.map((licao, indexLicao) => (
                          <SubsubSection>
                            <SectionTitle
                              onClick={() =>
                                handleLicaoSectionActive(
                                  indexModulo,
                                  indexLicao
                                )
                              }
                            >
                              Lição: {licao.titulo} [{licao.id}]
                              <Icon
                                class="icon"
                                name={
                                  licoesArrSectionActive[indexModulo][
                                    indexLicao
                                  ]
                                    ? "angle up"
                                    : "angle down"
                                }
                              ></Icon>
                            </SectionTitle>

                            <FieldsetContainer
                              active={
                                licoesArrSectionActive[indexModulo][indexLicao]
                              }
                            >
                              {licoesArrSectionActive[indexModulo][
                                indexLicao
                              ] &&
                                getFieldsets(
                                  "ead_licoes",
                                  licaoSection,
                                  licao,
                                  indexModulo,
                                  indexLicao
                                )}
                            </FieldsetContainer>
                          </SubsubSection>
                        ))}
                      </SubSection>
                    ))}
                </SubSectionsContainer>
              </Section>
            </FormContainer>
          </>
        )}

        <FixedBottomContainer>
          <Button color="green" onClick={saveChanges}>
            Salvar
          </Button>
          <Button color="grey" onClick={discardChanges}>
            Descartar minhas mudanças
          </Button>
          {academyHistory && (
            <>
              <Button color="blue" onClick={acceptUserChanges}>
                Publicar mudanças do usuário
              </Button>
              <Button color="orange" onClick={toggleOriginal}>
                {Number(original) == 0
                  ? "Ver original"
                  : "Ver com mudanças do usuário pendentes"}
              </Button>
            </>
          )}
        </FixedBottomContainer>
      </Content>
    </Container>
  );
};

export default CriarTeste;
